// extracted by mini-css-extract-plugin
export default {"article_sections_container":"article-sections_article_sections_container__duH23"};